import { Scope } from "@sentry/types";
import { Sentry } from "./initialize";
import { IContext } from "./types";

const isServer = typeof window === "undefined";

interface INotificationData {
  tags?: {
    [key: string]: any;
  };
  extras?: {
    [key: string]: any;
  };
}

const notifyError = (error: Error, data: INotificationData) => {
  Sentry.withScope((scope: Scope) => {
    if (error.message) {
      scope.setFingerprint([error.message]);
    }
    if (data.tags) {
      scope.setTags(data.tags);
    }
    if (data.extras) {
      scope.setExtras(data.extras);
    }
    Sentry.captureException(error);
  });
};

const notifyErrorWithContext = ({
  countryCode,
  err,
  isMobile,
  pathname,
  statusCode,
  query
}: IContext) => {
  notifyError(err, {
    extras: !isServer
      ? {
          pathname,
          query
        }
      : {},
    tags: {
      country: countryCode,
      mobile: String(isMobile),
      status: statusCode
    }
  });
};

export { Sentry, notifyError, notifyErrorWithContext };
